import { type DependencyList, useEffect } from 'react';

const useElectronListener = <T>(
  eventName: string,
  callback: (...args: T[]) => void,
  deps?: DependencyList
): void => {
  useEffect(() => {
    const subscription = window.dsDesktop.ipcRenderer.onWithSubscription(
      eventName,
      callback
    );

    return () => {
      window.dsDesktop.ipcRenderer.removeListener(eventName, subscription);
    };
  }, [eventName, callback, ...(deps ?? [])]);
};

export default useElectronListener;
